<template>
  <div class="assign-prices-wrapper">
    <!-- header card -->
    <b-card>
        <b-row>
          <b-col cols="12" md="3">
            <b-form-group
              :label="$t('apps.transactions.purchase.request.singular.requestor')"
              label-for="requestor"
            >
              <validation-provider
                #default="{ errors }"
                name="requestor"
                rules="required"
              >
                <v-select
                  inputId="requestor"
                  ref="firstFocusSelectInput"
                  v-model="form.requestorContactId"
                  :options="LOV.requestors"
                  :reduce="field => field.id"
                  label="label"
                  :state="errors.length > 0 ? false:null"
                  disabled
                  class="select-size-sm"
                  :placeholder="!actions.isPreview ? $t('apps.transactions.purchase.request.singular.requestor') : null"
                />
                  <!-- <template v-slot:option="option">
                    {{ option.user.user_name }} - {{ option.user.user_email }}
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    {{ option.user.user_name }} - {{ option.user.user_email }}
                  </template>
                </v-select> -->
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- Transaction No Field -->
          <b-col cols="12" md="3">
            <b-form-group
            :label="$t('apps.transactions.purchase.order.singular.transactionNo')"
            label-for="invoice-no"
            >
              <b-form-input
                id="invoice-no"
                size="sm"
                v-model="form.code"
                :placeholder="!actions.isPreview ? $t('apps.transactions.purchase.order.singular.transactionNo') : null"
                disabled
              />
            </b-form-group>
          </b-col>

          <!-- Date Field -->
          <b-col cols="12" md="3">
            <b-form-group
              :label="$t('globalSingular.date')"
              label-for="date"
            >
              <validation-provider
                #default="{ errors }"
                name="date"
                rules="required"
              >
                <flat-pickr
                  id="date"
                  :config="dateFormat"
                  v-model="form.date"
                  :state="errors.length > 0 ? false:null"
                  disabled
                  class="form-control form-control-sm"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12" md="3">
            <b-form-group
              :label="$t('globalSingular.workUnit')"
              label-for="work-unit">
              <validation-provider
                #default="{ errors }"
                name="work-unit"
                rules="required"
              >
                <v-select
                  id="work-unit"
                  v-model="form.workUnitId"
                  :options="LOV.workUnits"
                  :reduce="field => field.id"
                  label="name"
                  :state="errors.length > 0 ? false:null"
                  disabled
                  class="select-size-sm"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- Reference Code -->
          <!-- <b-col cols="12" md="3">
            <b-form-group
            :label="$t('globalSingular.referenceCode')"
            label-for="referenceCode"
            >
              <b-form-input
                id="referenceCode"
                size="sm"
                v-model="form.referenceCode"
                :placeholder="!actions.isPreview ? $t('globalSingular.referenceCode') : null"
                disabled
              />
            </b-form-group>
          </b-col> -->

          <!-- Tag Field -->
          <b-col cols="12" md="4">
            <b-form-group
                :label="$t('apps.transactionsCashbank.singular.tags')"
                label-for="tags">
              <v-select
                v-model="form.tags"
                inputId="tags"
                label="name"
                multiple
                disabled
                :options="LOV.tags"
                :reduce="field => field.id"
                :searchable="!actions.isPreview"
                :selectable="option => !actions.isPreview"
                class="select-size-sm"
                :placeholder="!actions.isPreview ? $t('apps.transactionsCashbank.singular.tags') : null"
              />
            </b-form-group>
          </b-col>

          <!-- <b-row> -->
          <!-- PIC Name Field -->
          <b-col cols="12" md="4">
            <b-form-group
            :label="$t('apps.transactions.purchase.request.singular.PICName')"
            label-for="picName"
            >
              <b-form-input
                id="picName"
                size="sm"
                v-model="form.picName"
                :placeholder="!actions.isPreview ? $t('apps.transactions.purchase.request.singular.PICName') : null"
                disabled
              />
            </b-form-group>
          </b-col>

          <!-- PIC Address Field -->
          <b-col cols="12" md="4">
            <b-form-group
            :label="$t('apps.transactions.purchase.request.singular.PICAddress')"
            label-for="picAddress"
            >
              <b-form-input
                id="picAddress"
                size="sm"
                v-model="form.picAddress"
                :placeholder="!actions.isPreview ? $t('apps.transactions.purchase.request.singular.PICAddress') : null"
                disabled
              />
            </b-form-group>
          </b-col>

          <!-- PIC Phone Field -->
          <b-col cols="12" md="4">
            <b-form-group
            :label="$t('apps.transactions.purchase.request.singular.PICPhone')"
            label-for="picPhone"
            >
              <b-form-input
                id="picPhone"
                size="sm"
                v-model="form.picPhone"
                :placeholder="!actions.isPreview ? $t('apps.transactions.purchase.request.singular.PICPhone') : null"
                disabled
              />
            </b-form-group>
          </b-col>

          <!-- CATEGORY -->
          <b-col cols="12" md="4">
            <b-form-group
              :label="$t('globalSingular.category')"
              label-for="category"
            >
              <validation-provider
                #default="{ errors }"
                name="category"
                rules="required"
              >
                <v-select
                  inputId="category"
                  ref="firstFocusSelectInput"
                  v-model="form.categoryId"
                  :options="LOV.categories"
                  :reduce="field => field.id"
                  label="name"
                  @option:selected="categoryChange"
                  :state="errors.length > 0 ? false:null"
                  disabled
                  class="select-size-sm"
                  :placeholder="!actions.isPreview ? $t('globalSingular.category') : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- SUB CATEGORY -->
          <b-col cols="12" md="4">
            <b-form-group
              :label="$t('globalSingular.subCategory')"
              label-for="requestor"
            >
              <validation-provider
                #default="{ errors }"
                name="requestor"
                rules="required"
              >
                <v-select
                  inputId="requestor"
                  ref="firstFocusSelectInput"
                  v-model="form.subCategoryId"
                  :options="LOV.subCategories"
                  :reduce="field => field.id"
                  label="name"
                  @option:selected="subCategoryChange"
                  :state="errors.length > 0 ? false:null"
                  disabled
                  class="select-size-sm"
                  :placeholder="!actions.isPreview ? $t('globalSingular.subCategory') : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- </b-row> -->
          <b-col cols="12" md="8">
            <b-form-group
              :label="$t('apps.transactionsCashbank.singular.notes')"
              label-for="notes">
              <b-form-textarea
                id="notes"
                size="sm"
                v-model="form.remark"
                rows="1"
                :placeholder="!actions.isPreview ? $t('apps.transactionsCashbank.placeholder.description') : null"
                disabled
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="4">
            <b-form-group
              :label="$t('globalSingular.priority')"
              label-for="priority">
                <validation-provider
                  #default="{ errors }"
                  name="priority"
                  rules="required"
                >
                  <v-select
                    inputId="priority"
                    v-model="form.priority"
                    :options="LOV.priorities"
                    :state="errors.length > 0 ? false:null"
                    disabled
                    class="select-size-sm"
                    :placeholder="!actions.isPreview ? $t('apps.transactions.purchase.request.singular.requestor') : null"
                  />
                    <!-- <template v-slot:option="option">
                      {{ option.user.user_name }} - {{ option.user.user_email }}
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      {{ option.user.user_name }} - {{ option.user.user_email }}
                    </template>
                  </v-select> -->
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
    </b-card>

    <b-card>
      <b-row >
        <b-col
          cols="12"
        >
          <validation-observer ref="formRef">
            <b-form @submit.prevent>

              <b-table
                id="refFormTable"
                ref="refFormTable"
                no-provider-paging
                no-provider-filtering
                :fields="tableColumns"
                :items="form.details"
                primary-key="id"
                show-empty
                responsive
                class="table-responsive"
              >
                <!-- Custom Header Column -->
                <template #head(actions)>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    class="mx-auto"
                  />
                </template>
                <!-- Column: Product -->
                <template #cell(product)="{ index }">
                  <span v-if="!products[index].isAdditional">
                    {{ products[index].product.name }} -
                    {{ form.details[index].remark }}
                  </span>
                  <b-form-group v-else>
                    <validation-provider
                      #default="{ errors }"
                      name="product"
                      rules="required"
                      :vid="`detail-${index}`"
                    >
                      <v-select
                        v-model="products[index].itemId"
                        :options="LOV.products"
                        :reduce="field => field.id"
                        label="name"
                        :state="errors.length > 0 ? false:null"
                        :disabled="actions.isPreview"
                        :clearable="false"
                        @option:selected="val => setAmountAndUom(index, val)"
                        class="select-size-sm"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </template>
                <!-- Column: Unit -->
                <template #cell(unit)="{ index }">
                  <span v-if="!products[index].isAdditional">
                    {{ products[index].product.uom.uom }}
                  </span>
                  <b-form-group v-else>
                    <validation-provider
                      #default="{ errors }"
                      name="unit"
                      rules="required"
                      :vid="`detail-${index}`"
                    >
                      <v-select
                        v-model="form.details[index].uomId"
                        :options="LOV.uoms"
                        :reduce="field => field.id"
                        label="uom"
                        :state="errors.length > 0 ? false:null"
                        :disabled="actions.isPreview"
                        :clearable="false"
                        class="select-size-sm"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </template>
                <!-- Column: Qty -->
                <template #cell(qty)="{ index }">
                  <span v-if="!products[index].isAdditional">
                    {{ form.details[index].quantity }}
                  </span>
                  <b-form-group v-else>
                    <validation-provider
                      #default="{ errors }"
                      name="quantity"
                      rules="required"
                      :vid="`detail-${index}`"
                    >
                      <b-form-input
                        class="text-right"
                        type="number"
                        min="1"
                        v-model.number="form.details[index].quantity"
                        :state="errors.length > 0 ? false:null"
                        :placeholder="!actions.isPreview ? $t('apps.transactionsCashbank.placeholder.description') : null"
                        :disabled="actions.isPreview"
                        @blur="updateItemAmount(index)"
                        size="sm"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </template>
                <!-- Est. Price -->
                <template #cell(estPrice)="{ index }">
                  {{ products[index].price }}
                </template>
                <!-- Est. Price -->
                <template #cell(estTotalPrice)="{ index }">
                  {{ products[index].total }}
                </template>
                <!-- Column: Price -->
                <template v-for="(id, idxVendor) in form.vendor" v-slot:[`cell(price_vendor_${id})`]="{ index }">
                  <div :key="id">
                    <b-form-group
                      label="Price per Unit"
                      label-for="priority"
                      class="text-left"
                    >
                      <!-- <validation-provider
                        #default="{ errors }"
                        name="price"
                        rules="required"
                        :vid="`detail-${index}`"
                      > -->
                        <b-input-group>
                          <cleave
                            :key="index"
                            v-model="form.details[index].amount[idxVendor].amount"
                            @blur="updateItemAmount(index, idxVendor)"
                            class="form-control text-right form-control-sm"
                            :options="numeric"
                            :disabled="actions.isPreview"
                            :placeholder="actions.isPreview ? null : '100,000'"
                          />
                          <b-input-group-append is-text>
                            <b-form-radio :disabled="actions.isPreview" v-model="form.details[index].amount[idxVendor].selected" :value="true" @change="checked => conditionCheckbox(checked, index, idxVendor)" ></b-form-radio>
                          </b-input-group-append>
                        </b-input-group>
                        <!-- <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider> -->
                    </b-form-group>
                    <div class="d-flex justify-content-between font-italic">
                      <span>Tax Base</span>
                      <span>{{ formatCurrency(form.details[index].amount[idxVendor].taxBaseAmount) }}</span>
                    </div>
                    <b-form-group
                      label="Tax"
                      label-for="priority"
                      class="text-left mt-1"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="tax"
                        rules="required"
                        :vid="`detail-${index}`"
                      >
                        <v-select
                          v-model="form.details[index].amount[idxVendor].taxId"
                          :options="LOV.taxes"
                          :reduce="field => field.id"
                          label="name"
                          :disabled="actions.isPreview"
                          @option:selected="updateItemAmount(index, idxVendor)"
                          class="select-size-sm"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                    <div class="d-flex justify-content-between font-italic">
                      <span>Tax amount</span>
                      <span>{{ formatCurrency(form.details[index].amount[idxVendor].taxAmount) }}</span>
                    </div>
                    <div class="d-flex justify-content-between font-weight-bolder font-italic">
                      <span>Sub Total</span>
                      <span>{{ formatCurrency(form.details[index].amount[idxVendor].billAmount) }}</span>
                    </div>
                  </div>
                </template>

                <template #cell(actions)="{ index }">
                  <b-button
                    variant="flat-danger"
                    class="btn-icon"
                    :disabled="form.details.length <= 1"
                    @click="removeRow(index)"
                  >
                    <feather-icon icon="MinusIcon" />
                  </b-button>
                </template>
                <!-- Column: Discount Amount -->
                <!-- <template #cell(discount)="{ index }">
                  <b-form-group>
                    <b-form-input
                      class="text-right"
                      type="number"
                      min="0"
                      v-model.number="form.details[index].discPercent"
                      :placeholder="!actions.isPreview ? $t('apps.transactionsCashbank.placeholder.description') : null"
                      disabled
                      @blur="updateItemAmount(index)"
                      size="sm"
                    />
                  </b-form-group>
                </template> -->
                <!-- Column: Tax Amount -->
                <!-- <template #cell(tax)="{ index }">
                  <b-form-group>
                    <validation-provider
                      #default="{ errors }"
                      name="tax"
                      rules="required"
                      :vid="`detail-${index}`"
                    >
                      <v-select
                        v-model="form.details[index].taxId"
                        :options="LOV.taxes"
                        :reduce="field => field.id"
                        label="name"
                        :state="errors.length > 0 ? false:null"
                        disabled
                        :clearable="false"
                        @option:selected="updateItemAmount(index)"
                        class="select-size-sm"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </template> -->
                <!-- Column: Total Amount -->
                <!-- <template #cell(total)="{ index }">
                  <span class="font-weight-bolder d-block text-right text-nowrap align-top form-control border-0 pr-0">
                    {{ formatCurrency(form.details[index].baseAmount) }}
                  </span>
                </template> -->
                <!-- Column: Actions -->
                <!-- <template #cell(actions)="{ index }">
                  <b-button
                    variant="flat-danger"
                    class="btn-icon"
                    :disabled="form.details.length <= 2"
                    @click="removeRow(index)"
                  >
                    <feather-icon icon="MinusIcon" />
                  </b-button>
                </template> -->
                <!-- Costum Footer -->
                <template v-slot:custom-foot="{}">
                  <b-tr>
                    <b-td :colspan="5 + form.vendor.length" class="p-0">
                      <b-button
                        v-if="!actions.isPreview"
                        variant="outline-primary"
                        block
                        @click="addRow"
                      >
                        <feather-icon
                          icon="PlusIcon"
                        />
                        {{ $t('globalActions.addMore') }}
                      </b-button>
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-td colspan="5" class="h4 mb-0 font-weight-bolder text-right">
                      Total Estimate
                    </b-td>
                    <!-- <b-td class="text-right">125000</b-td> -->
                    <b-td v-for="(id, idxVendor) in form.vendor" class="text-right" :key="id">
                      <!-- 125000 -->
                      <span class="font-weight-bolder font-italic">{{ formatCurrency(sumEstimatePerVendor(idxVendor)) }}</span>
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-td colspan="5" class="h4 mb-0 font-weight-bolder text-right">
                      Total Per Selected Item
                    </b-td>
                    <!-- <b-td class="text-right">125000</b-td> -->
                    <b-td v-for="(id, idxVendor) in form.vendor" class="text-right" :key="id">
                      <!-- 125000 -->
                      <span class="font-weight-bolder font-italic">{{ formatCurrency(sumAssignPricePerVendor(idxVendor)) }}</span>
                    </b-td>
                  </b-tr>
                  <!-- <b-tr>
                    <b-td></b-td>
                  </b-tr> -->
                  <!-- <b-tr>
                    <b-td colspan="2">&nbsp;</b-td>
                    <b-td class="pl-5 py-1">
                      <div class="h5 mb-0 font-weight-bolder">{{ $t('globalSingular.subTotal') }}</div>
                    </b-td>
                    <b-td class="text-right">
                      <div class="h5 mb-0 font-weight-bolder">{{ formatCurrency(sumOfAmount) }}</div>
                    </b-td>
                    <b-td>&nbsp;</b-td>
                  </b-tr> -->
                  <!-- <b-tr>
                    <b-td colspan="2" class="border-0">&nbsp;</b-td>
                    <b-td class="border-0 pb-1 pl-5">
                      <div class="h6 mb-0 font-weight-bolder">{{ $t('globalSingular.discount') }}</div>
                    </b-td>
                    <b-td class="border-0 text-right align-baseline">
                      <div class="h6 mb-0 font-weight-bolder text-danger"> -{{ formatCurrency( form.sumOfDiscAmount + form.sumOfDiscGlobalAmount) }}</div>
                    </b-td>
                    <b-td class="border-0">&nbsp;</b-td>
                  </b-tr> -->
                  <!-- <b-tr>
                    <b-td colspan="2" class="border-0">&nbsp;</b-td>
                    <b-td class="border-0 pb-1 pl-5">
                      <div class="h6 mb-0 font-weight-bolder">{{ $t('globalSingular.taxBase') }}</div>
                    </b-td>
                    <b-td class="border-0 text-right align-baseline">
                      <div class="h6 mb-0 font-weight-bolder">{{ formatCurrency( form.sumOfTaxBaseAmount) }}</div>
                    </b-td>
                    <b-td class="border-0">&nbsp;</b-td>
                  </b-tr> -->
                  <!-- <b-tr>
                    <b-td colspan="2" class="border-0">&nbsp;</b-td>
                    <b-td class="border-0 pb-1 pl-5">
                      <div class="h6 mb-0 font-weight-bolder">{{ $t('globalSingular.tax') }}</div>
                    </b-td>
                    <b-td class="border-0 text-right align-baseline">
                      <div class="h6 mb-0 font-weight-bolder">{{ formatCurrency( form.sumOfTaxAmount) }}</div>
                    </b-td>
                    <b-td class="border-0">&nbsp;</b-td>
                  </b-tr> -->
                  <!-- <b-tr>
                    <b-td colspan="2" class="border-0">&nbsp;</b-td>
                    <b-td colspan="2" class="border-0 pl-5 py-0">
                      <hr>
                    </b-td>
                    <b-td class="border-0">&nbsp;</b-td>
                  </b-tr> -->
                  <!-- <b-tr>
                    <b-td colspan="2" class="border-0">
                      &nbsp;
                    </b-td>
                    <b-td class="border-0 align-baseline pl-5">
                      <div class="h4 mb-0 font-weight-bolder">{{ $t('globalSingular.total') }}</div>
                    </b-td>
                    <b-td class="border-0 text-right align-baseline pl-4">
                      <div class="h4 mb-0 font-weight-bolder">{{ formatCurrency( form.sumOfBillAmount) }}</div>
                    </b-td>
                    <b-td class="border-0">&nbsp;</b-td>
                  </b-tr> -->
                </template>
              </b-table>

              <b-row class="my-1">
                <!-- Description Field -->
                <b-col cols="12" md="12">

                </b-col>
              </b-row>

              <div class="mt-3 d-flex flex-sm-column flex-md-row justify-content-between">
                <b-button
                  class="mb-sm-1 mb-md-0"
                  :variant="actions.isPreview ? 'outline-secondary' : 'outline-primary'"
                  :to="{ name: 'apps-transactions-purchase-request-assign-price-list' }"
                >
                  <feather-icon
                    icon="ArrowLeftIcon"
                  />
                  {{ $t('globalActions.backToList') }}
                </b-button>

                <b-button
                  v-if="actions.isPreview"
                  class=" mb-sm-1 mb-md-0"
                  variant="outline-danger"
                  @click="handleDelete"
                >
                  <feather-icon
                    icon="Trash2Icon"
                  />
                  {{ $t('globalActions.delete') }}
                </b-button>

                <!-- <b-button
                  v-if="actions.isPreview"
                  class=" mb-sm-1 mb-md-0"
                  variant="outline-primary"
                  :to="{ name: 'apps-transactions-purchase-invoice-prints', params: { id: paramsId }}"
                >
                  <feather-icon
                    icon="EyeIcon"
                  />
                  {{ $t('globalActions.prints') }}
                </b-button> -->

                <b-button
                  v-if="!actions.isPreview"
                  class=" mb-sm-1 mb-md-0"
                  variant="primary"
                  @click="handleSubmit"
                >
                  <feather-icon
                    icon="CheckIcon"
                  />
                  {{ $t('globalActions.submit') }}
                </b-button>

                <b-button
                  v-if="actions.isPreview && isUserApprovers"
                  class=" mb-sm-1 mb-md-0"
                  variant="success"
                  @click="handleGeneratePO"
                >
                  <feather-icon
                    icon="CheckIcon"
                  />
                  {{ $t('globalActions.approve') }}
                </b-button>

                <!-- <b-button-group v-if="!actions.isPreview">
                  <b-dropdown
                    variant="primary"
                    right
                    split
                    @click="handleSubmit"
                  >
                    <template #button-content>
                      <feather-icon
                      icon="SaveIcon"
                    />
                    {{ $t('globalActions.submit') }}
                    </template>
                    <b-dropdown-item @click="handleGeneratePO">Submit & Generate PO</b-dropdown-item>
                  </b-dropdown>
                </b-button-group> -->

                <!-- <b-button
                  v-if="!actions.isPreview"
                  variant="primary"
                  type="submit"
                  @click="handleSubmit"
                >
                  <feather-icon
                    icon="SaveIcon"
                  />
                  {{ $t('globalActions.submit') }}
                </b-button> -->

                <b-button
                  v-if="actions.isPreview"
                  variant="outline-primary"
                  @click="changeToEdit"
                >
                  <feather-icon
                    icon="EditIcon"
                  />
                  {{ $t('globalActions.assignPrice') }}
                </b-button>
              </div>
            </b-form>
          </validation-observer>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BTable,
  BTr,
  BTd,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BFormRadio,
  BForm,
  BFormTextarea,
  BButton
  // BButtonGroup,
  // BDropdown,
  // BDropdownItem
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Cleave from 'vue-cleave-component'
import { ref, onMounted, computed } from '@vue/composition-api'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import { formatCurrency } from '@/utils/formatter'
import flatPickr from 'vue-flatpickr-component'

import useFormResource from '@/comp-functions/useFormResource'
import usePushTags from '@/comp-functions/utils/usePushTags'
import useLocalization from '@/comp-functions/utils/useLocalization'
import storestate from '@/store/index'

const DETAIL_INVOICE = {
  rowNumber: 1,
  itemId: 'Product',
  remark: '',
  uomId: 'Unit',
  quantity: 1,
  amount: [{
    id: null,
    amount: 0,
    taxRate: null,
    taxId: null,
    discPercent: 0,
    discAmount: 0,
    baseAmount: 0,
    taxBaseAmount: 0,
    taxAmount: 0,
    billAmount: 0,
    selected: false 
  }],
  discPercent: 0,
  discAmount: 0,
  baseAmount: 0,
  discGlobalPercent: 0,
  discGlobalAmount: 0,
  taxBaseAmount: 0,
  taxId: null,
  taxRate: 10,
  taxAmount: 0,
  billAmount: 0
}

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BTr,
    BTd,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BFormRadio,
    BForm,
    BFormTextarea,
    BButton,
    // BButtonGroup,
    // BDropdown,
    // BDropdownItem,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    Cleave,
    flatPickr
  },
  setup () {
    const {
      paramsId,
      formRef,
      firstFocusSelectInput,
      get,
      actions,
      changeToEdit,
      show,
      destroy,
      store
    } = useFormResource({ url: 'transaction/purchase/request', localeContextPath: 'apps.transactions.purchase.request.singular.request', redirectPathName: 'apps-transactions-purchase-request-assign-price' })

    const userApproverIds = ref([])
    const suppliers = ref([])
    const products = ref([
      {
        isAdditional: false,
        itemId: null,
        product: {
          name: null,
          uom: {
            uom: null
          }
        },
        price: null,
        total: null
      }
    ])

    const { $t } = useLocalization()

    const LOV = ref({
      workUnits: [],
      products: [],
      requestors: [],
      suppliers: [],
      categories: [],
      subCategories: [],
      uoms: [],
      tags: [],
      priorities: [
        'URGENT',
        'NORMAL'
      ],
      taxes: []
    })

    const getSuppliers = async () => {
      LOV.value.suppliers = await get({ url: 'value/contact/supplier' })
    }

    const getCategories = async () => {
      LOV.value.categories = await get({ url: 'value/product-category' })
    }

    const getSubCategories = async categoryId => {
      LOV.value.subCategories = await get({ url: `value/product-sub-category?category_id=${categoryId}` })
    }

    const getWorkUnits = async () => {
      LOV.value.workUnits = await get({ url: 'value/work-unit' })
    }

    const getRequestor = async () => {
      LOV.value.requestors = await get({ url: 'value/contact/employee' })
    }

    const getProducts = async subCategoryId => {
      LOV.value.products = await get({ url: `value/product?product_type=expense&is_buying=true&sub_category_id=${subCategoryId}`})
    }

    const getUoms = async () => {
      LOV.value.uoms = await get({ url: 'value/uom'})
    }

    const getTaxes = async () => {
      LOV.value.taxes = await get({ url: 'value/tax'})
    }

    const getTags = async () => {
      LOV.value.tags = await get({ url: 'value/tag'})
    }

    const tableColumns = ref([
      { key: 'product',  label: $t('apps.transactions.purchase.singular.product'), thClass: '', tdClass: 'py-1 align-center' },
      { key: 'unit', label: $t('apps.transactions.purchase.singular.unit'), thClass: 'text-right ', tdClass: 'py-1 align-center text-right'},
      { key: 'qty', label: $t('apps.transactions.purchase.singular.qty'), thClass: 'text-right ', tdClass: 'py-1 align-center text-right'},
      { key: 'estPrice', label: $t('globalSingular.estPrice'), thClass: 'text-right', tdClass: 'py-1 align-center text-right'},
      { key: 'estTotalPrice', label: $t('globalSingular.estTotalPrice'), thClass: 'text-right', tdClass: 'py-1 align-center text-right'}
      // { key: 'discount', label: $t('apps.transactions.purchase.singular.discount'), thClass: 'text-right ', tdClass: 'py-1 align-top text-right'},
      // { key: 'tax', label: $t('apps.transactions.purchase.singular.tax'), thClass: 'text-right ', tdClass: 'py-1 align-top text-right'},
      // { key: 'total', label: $t('apps.transactions.purchase.singular.total'), thClass: 'text-right ', tdClass: 'py-1 align-top text-right'},
      // { key: 'actions', thClass: 'text-right ', tdClass: 'py-1 align-top text-right pr-0'}
    ])

    const isInvoiced = ref(true)

    const form = ref({
      code: '',
      priority: '',
      date: '',
      vendor: [],
      categoryId: '',
      subCategoryId: '',
      requestorContactId: '',
      picName: '',
      picAddress: '',
      picPhone: '',
      remark: '',
      workUnitId: '',
      tags: [],
      details: [
        // doing 'tricked' placeholder for vue-select accountId
        { ...DETAIL_INVOICE }
      ]
    })

    const companyActive = storestate.state.user.currentCompany
    const dateFormat = ref({
      dateFormat: 'd/m/Y',
      disable: [
        function (date) {
          return (date.getTime() < (new Date(companyActive.closing_year,  companyActive.closing_month, 1).getTime()))
        }
      ]
    })

    const numeric = ref({
      numeral: true,
      numeralThousandsGroupStyle: 'thousand'
    })

    const sumOfAmount = ref(0)

    const sumItemAmount = () => {
      sumOfAmount.value = form.value.details.reduce((accumulator, {quantity, amount}) => accumulator + (amount * quantity), 0)
      form.value.sumOfQuantity = form.value.details.reduce((accumulator, {quantity}) => accumulator + quantity, 0)
      form.value.sumOfAmount = form.value.details.reduce((accumulator, {amount}) => accumulator + amount, 0)
      form.value.sumOfDiscAmount = form.value.details.reduce((accumulator, {discAmount}) => accumulator + discAmount, 0)
      form.value.sumOfBaseAmount = form.value.details.reduce((accumulator, {baseAmount}) => accumulator + baseAmount, 0)
      form.value.sumOfDiscGlobalAmount = form.value.details.reduce((accumulator, {discGlobalAmount}) => accumulator + discGlobalAmount, 0)
      form.value.sumOfTaxBaseAmount = form.value.details.reduce((accumulator, {taxBaseAmount}) => accumulator + taxBaseAmount, 0)
      form.value.sumOfTaxAmount = form.value.details.reduce((accumulator, {taxAmount}) => accumulator + taxAmount, 0)
      form.value.sumOfBillAmount = form.value.details.reduce((accumulator, {billAmount}) => accumulator + billAmount, 0)
      form.value.outstandingAmount = form.value.sumOfBillAmount
    }


    const updateItemAmount = (index, idxVendor) => {
      const baseAmountBeforeDisc = form.value.details[index].quantity * form.value.details[index].amount[idxVendor].amount
      // console.log('form.value.details[index].amount[idxVendor]', form.value.details[index].amount[idxVendor])
      // console.log('baseAmountBeforeDisc', baseAmountBeforeDisc)
      if (!form.value.details[index].amount[idxVendor].taxRate) {
        const tax = LOV.value.taxes.find(field => field.id === form.value.details[index].amount[idxVendor].taxId)
        // console.log('tax', tax)
        form.value.details[index].amount[idxVendor].taxRate = tax.rate || 0
      }
      form.value.details[index].amount[idxVendor].discAmount = (baseAmountBeforeDisc * form.value.details[index].amount[idxVendor].discPercent || 0) / 100
      form.value.details[index].amount[idxVendor].baseAmount = baseAmountBeforeDisc - (form.value.details[index].amount[idxVendor].discAmount || 0)
      form.value.details[index].amount[idxVendor].taxBaseAmount = form.value.details[index].amount[idxVendor].baseAmount - (form.value.details[index].amount[idxVendor].discGlobalAmount || 0)
      form.value.details[index].amount[idxVendor].taxAmount = (form.value.details[index].amount[idxVendor].taxBaseAmount * (form.value.details[index].amount[idxVendor].taxRate || 0)) / 100
      form.value.details[index].amount[idxVendor].billAmount = form.value.details[index].amount[idxVendor].taxBaseAmount + (form.value.details[index].amount[idxVendor].taxAmount || 0)
      sumItemAmount()
    }

    // SET AMOUNT AND UNIT BASED ON SELECTED PRODUCT
    const setAmountAndUom = (index, selectedValue) => {
      // @TODO : SET AMOUNT AND UNIT BASED ON SELECTED PRODUCT
      console.log('selectedValue', selectedValue)
      form.value.details[index].itemId = selectedValue.id
      form.value.details[index].uomId = selectedValue.uom_id
      products.value[index].product.name = selectedValue.name
      products.value[index].product.uom.uom = selectedValue.uom.uom
      products.value[index].price = parseFloat(selectedValue.buying_amount)
      products.value[index].total = parseFloat(selectedValue.buying_amount) * 1
      console.log('products.value', products.value)
      // console.log('product', product)
      // console.log('selectedProduct', selectedProduct)
      // form.value.details[index].uomId = id
      // form.value.details[index].amount = parseInt(buying_amount)
      // updateItemAmount(index)
    }
    

    // Add row details
    const addRow = () => {
      // const detailInvoice = {...DETAIL_INVOICE}
      // detailInvoice.rowNumber = form.value.details.length + 1
      const detail = {}
        detail.rowNumber = form.value.details.length + 1
        detail.itemId = null
        detail.remark = ''
        detail.uomId = ''
        detail.quantity = 1
        if (suppliers.value.length > 0) {
          // if (amount) {
          //   detail.amount = 0
          // } else {
            detail.amount = suppliers.value.map(supplier => { 
              return {id: supplier.id, amount: 0, selected: false} 
            })
          // }
        } else {
          detail.amount = [{ id: null, amount: 0, selected: false }]
        }
      form.value.details.push({
        rowNumber: form.value.details.length + 1,
        ...detail
      })
      products.value.push({
          isAdditional: true,
          itemId: null,
          product: {
            name: null,
            uom: {
              uom: null
            }
          },
          price: 0,
          total: 0
        })
    }

    const userId = storestate.state.user.id
    // will get data to show the preview
    const getDataPreview = async () => {
      const data = await show()
      userApproverIds.value = data.user_approvers_id
      isInvoiced.value = data.is_invoiced
      suppliers.value = data.suppliers
      form.value.contactId = data.contact_id
      form.value.priority = data.priority
      form.value.code = data.code
      form.value.date = data.date
      form.value.vendor = data.vendor
      form.value.categoryId = data.category_id
      form.value.subCategoryId = data.sub_category_id
      form.value.requestorContactId = data.requestor_contact_id
      form.value.picName = data.pic_name
      form.value.picAddress = data.pic_address
      form.value.picPhone = data.pic_phone
      form.value.workUnitId = data.work_unit_id
      form.value.remark = data.remark
      form.value.tags = data.tags ? data.tags.map(tag => parseInt(tag)) : []
      products.value = []
      form.value.details = data.details.map(field => {
        const detail = {}
        detail.rowNumber = field.row_number
        detail.itemId = field.item_id
        detail.remark = field.remark
        detail.uomId = field.uom_id
        detail.quantity = parseFloat(field.quantity)
        if (data.suppliers.length > 0) {
          if (field.amount) {
            detail.amount = field.amount
          } else {
            detail.amount = data.suppliers.map(supplier => { 
              return {id: supplier.id, amount: supplier, selected: false} 
            })
          }
        } else {
          detail.amount = [{ id: null, amount: 0, selected: false }]
        }
        products.value.push({
          isAdditional: false,
          itemId: field.item_id,
          product: field.product ? field.product : {},
          price: formatCurrency(parseFloat(field.product.buying_amount | 0)),
          total: formatCurrency(parseFloat(field.product.buying_amount | 0) * detail.quantity)
        })
        // detail.discPercent = (parseFloat(field.disc_amount) /  parseFloat(field.amount)) * 100
        // detail.discAmount = parseFloat(field.disc_amount)
        // detail.baseAmount = parseFloat(field.base_amount)
        // detail.discGlobalPercent = parseFloat(field.disc_global_percent)
        // detail.discGlobalAmount = parseFloat(field.disc_global_amount)
        // detail.taxBaseAmount = parseFloat(field.tax_base_amount)
        // detail.taxId = parseFloat(field.tax_id)
        // detail.taxRate = (parseFloat(field.tax_amount) /  parseFloat(field.dpp_amount)) * 100
        // detail.taxAmount = parseFloat(field.tax_amount)
        // detail.billAmount = parseFloat(field.bill_amount)
        return detail
      })
      if (data.suppliers.length > 0) {
        data.suppliers.map(supplier => {
          tableColumns.value.push(
            { key: `price_vendor_${supplier.id}`, label: supplier.name, thClass: 'text-right', tdClass: 'py-1 align-center text-right'}
          )
        })
        tableColumns.value.push({ key: 'actions', thClass: 'text-right ', tdClass: 'py-1 align-top text-right pr-0'})
      }
      getSubCategories(data.category_id)
      getProducts(data.sub_category_id)
      sumItemAmount()
    }

    const isUserApprovers = computed(() => userApproverIds.value.includes(userId))

    // Remove row details
    const removeRow =  (index) => {
      if (form.value.details.length <= 1) return false
      form.value.details.splice(index, 1)
    }

    const categoryChange = option => getSubCategories(option.id)
    const subCategoryChange = option => getProducts(option.id)

    const sumAssignPricePerVendor = idxVendor => form.value.details.reduce((accum, { amount }) => {
      let realAmount = 0
      if (amount[idxVendor].selected) {
        realAmount = amount[idxVendor].billAmount ? amount[idxVendor].billAmount : 0
      }
      return accum + parseFloat(realAmount)
    }, 0)

    const sumEstimatePerVendor = idxVendor => form.value.details.reduce((accum, { amount }) => {
      let billAmount = amount[idxVendor].billAmount ? amount[idxVendor].billAmount : 0
      return accum + parseFloat(billAmount)
    }, 0)

    // const sumPrice = computed(() => {
    //   return form.vendor.reduce((a, b) => {
    //     return a + b[i]
    //   }, 0)
    // })

    onMounted(() => {
      getSuppliers()
      getCategories()
      getWorkUnits()
      getRequestor()
      // getProducts()
      getUoms()
      getTags()
      getTaxes()
      if (paramsId) {
        actions.value.isPreview = true
        getDataPreview()
      }
      // tableColumns.value = [
      //   { key: 'product',  label: $t('apps.transactions.purchase.singular.product'), thClass: '', tdClass: 'py-1 align-top pl-0' },
      //   { key: 'unit', label: $t('apps.transactions.purchase.singular.unit'), thClass: 'text-right ', tdClass: 'py-1 align-top text-right'},
      //   { key: 'qty', label: $t('apps.transactions.purchase.singular.qty'), thClass: 'text-right ', tdClass: 'py-1 align-top text-right'},
      //   // { key: 'price', label: $t('apps.transactions.purchase.singular.price'), thClass: 'text-right width-20-per', tdClass: 'py-1 align-top text-right'},
      //   // { key: 'discount', label: $t('apps.transactions.purchase.singular.discount'), thClass: 'text-right ', tdClass: 'py-1 align-top text-right'},
      //   // { key: 'tax', label: $t('apps.transactions.purchase.singular.tax'), thClass: 'text-right ', tdClass: 'py-1 align-top text-right'},
      //   // { key: 'total', label: $t('apps.transactions.purchase.singular.total'), thClass: 'text-right ', tdClass: 'py-1 align-top text-right'},
      //   { key: 'actions', thClass: 'text-right ', tdClass: 'py-1 align-top text-right pr-0'}
      // ]
    })

    const { pushTagsToAPI } = usePushTags()
    const pushTags = async newTag => {
      const id = await pushTagsToAPI(newTag)
      form.value.tags[form.value.tags.findIndex(val => val === newTag.id)] = id
    }

    const conditionCheckbox = (checked, indexDetail, indexVendor) => {
      // console.log('checked', checked)
      // console.log('indexDetail', indexDetail)
      // console.log('indexVendor', indexVendor)
      const data = form.value.details[indexDetail].amount
        .map((field, idx) => {
          if (idx !== indexVendor) {
            field.selected = false
          } else {
            field.selected = checked
          }
          return field
        })
      // console.log(data)
      form.value.details[indexDetail].amount = data
      // console.log('form ', form.value.details[indexDetail])
    }

    return {
      isUserApprovers,
      userApproverIds,
      conditionCheckbox,
      sumAssignPricePerVendor,
      sumEstimatePerVendor,
      products,
      categoryChange,
      subCategoryChange,
      formatCurrency,
      pushTags,
      required,
      LOV,
      tableColumns,
      form,
      addRow,
      removeRow,
      dateFormat,
      sumOfAmount,
      updateItemAmount,
      setAmountAndUom,
      numeric,
      paramsId,
      isInvoiced,
      formRef,
      firstFocusSelectInput,
      get,
      actions,
      changeToEdit,
      show,
      destroy,
      store
    }
  },
  methods: {
    handleDelete () {
      this.destroy(this.$swal)
    },
    async handleSubmit () {
      // this.form.isInvoiced = true
      this.store({
        $swal: this.$swal,
        data: this.form
      })
    },
    async handleGeneratePO () {
      this.form.isApproved = true
      this.form.isGeneratePO = true
      this.store({
        $swal: this.$swal,
        data: this.form
      })
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-sweetalert.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.assign-prices-wrapper {
  .input-group-text {
    padding-top: 0;
    padding-bottom: 0;
  }

}
</style>
